//本地导入
import request from "../request";

//用户排行榜
export const userRankingList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/rank/user/list",
  });
